import { Phone, ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { BUSINESS, IMAGES } from "../lib/site";

const CTASection = ({ testid = "cta-section" }) => (
    <section className="relative overflow-hidden border-y border-brand-line" data-testid={testid}>
        <div className="absolute inset-0">
            <img
                src={IMAGES.chipTexture}
                alt=""
                aria-hidden="true"
                className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-brand-ink/85" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8 py-24 text-center">
            <Reveal>
                <p className="font-mono text-xs uppercase tracking-[0.25em] text-brand-amber mb-5">
                    Same-week guarantee · Mon–Sat 7AM–6PM
                </p>
                <h2 className="font-display font-black uppercase text-brand-cream text-4xl sm:text-6xl lg:text-7xl tracking-tight leading-[0.92] mb-10">
                    Ready to take back
                    <br />
                    your <span className="text-brand-amber">yard?</span>
                </h2>
                <div className="flex flex-col sm:flex-row justify-center gap-4">
                    <a
                        href={BUSINESS.phoneTel}
                        data-testid="cta-call-btn"
                        className="inline-flex items-center justify-center gap-3 bg-brand-amber text-brand-ink font-bold text-lg px-8 py-4 rounded-full hover:bg-brand-amberHover transition-colors"
                    >
                        <Phone className="w-5 h-5" />
                        Call {BUSINESS.phoneDisplay}
                    </a>
                    <a
                        href="/quote"
                        data-testid="cta-quote-link"
                        className="inline-flex items-center justify-center gap-3 border border-brand-cream/30 text-brand-cream font-semibold text-lg px-8 py-4 rounded-full hover:border-brand-amber hover:text-brand-amber transition-colors"
                    >
                        Free Quote
                        <ArrowRight className="w-5 h-5" />
                    </a>
                </div>
            </Reveal>
        </div>
    </section>
);

export default CTASection;
